export enum LineeFinanziamentoEnum {
  FSE = <any>"FSE",
  PNRR = <any>"PNRR",
  PATTO_PER_IL_LAVORO = <any>"PATTO_PER_IL_LAVORO",
  LEGGE681999 = <any>"LEGGE681999",
  ALTRO = <any>"ALTRO"
}


// optional: Record type annotation guaranties that 
// all the values from the enum are presented in the mapping
export const LineeFinanziamentoLabelMapping: Record<LineeFinanziamentoEnum, string> = {
  [LineeFinanziamentoEnum.FSE]: "FSE",
  [LineeFinanziamentoEnum.PNRR]: "PNRR",
  [LineeFinanziamentoEnum.PATTO_PER_IL_LAVORO]: "PATTO_PER_IL_LAVORO",
  [LineeFinanziamentoEnum.LEGGE681999]: "L. 68/1999",
  [LineeFinanziamentoEnum.ALTRO]: "Altro",
};